import { render, staticRenderFns } from "./StructureViewer.vue?vue&type=template&id=23c90e81&"
import script from "./StructureViewer.vue?vue&type=script&lang=js&"
export * from "./StructureViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports